import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';

export function FarmCard({ farm }) {
  return (
    <Link 
      to={`/farm/${farm.farm_id}`}
      className="group block bg-cream rounded-[2rem] overflow-hidden border border-brown/10 hover:shadow-hover transition-all duration-500"
      data-testid={`farm-card-${farm.farm_id}`}
    >
      {/* Image */}
      <div className="relative overflow-hidden aspect-[16/9]">
        <img
          src={farm.image_url}
          alt={farm.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-dark/60 to-transparent"></div>
        <div className="absolute bottom-4 left-4 right-4">
          <div className="flex items-center gap-2 text-cream/90 mb-2">
            <MapPin className="w-4 h-4" />
            <span className="font-manrope text-sm">{farm.location}</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-8">
        <h3 className="font-playfair text-2xl font-semibold text-dark mb-3 group-hover:text-forest transition-colors">
          {farm.name}
        </h3>
        
        <p className="text-dark/60 font-manrope mb-4 line-clamp-2">
          {farm.description}
        </p>

        {/* Specialties */}
        <div className="flex flex-wrap gap-2 mb-6">
          {farm.specialties.slice(0, 3).map((specialty, index) => (
            <span key={index} className="badge-local text-xs">
              {specialty}
            </span>
          ))}
        </div>

        <div className="flex items-center gap-2 text-forest font-manrope font-medium group-hover:gap-3 transition-all">
          View Farm
          <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
}
